import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import { NotaValidator } from 'src/app/utils/nota-validator'
import { UnespCoreMessageService } from 'src/libs/unesp-core'
import { TipoProva } from 'src/app/enums/tipo-prova'

@Component({
  selector: 'inscricoes-input-nota-avaliacao',
  templateUrl: './input-nota-avaliacao.component.html',
  styleUrls: ['./input-nota-avaliacao.component.scss'],
})
export class InputNotaAvaliacaoComponent implements OnInit, OnDestroy {
  @Input() disabled: boolean = false
  @Input() notaInicial: number | null = null
  @Input() peso: number = 0
  @Input() descricaoProva?: string

  @Output() confirmarNota: EventEmitter<number> = new EventEmitter<number>()
  @Output() notaChanged: EventEmitter<void> = new EventEmitter<void>()

  nota: number | null = null
  saved = false
  private savedTimeout?: ReturnType<typeof setTimeout>

  constructor(private readonly unespCoreMessageService: UnespCoreMessageService) {}

  ngOnInit(): void {
    if (this.notaInicial !== null) {
      this.nota = this.notaInicial
    }
  }

  ngOnDestroy(): void {
    if (this.savedTimeout) clearTimeout(this.savedTimeout)
  }

  validateNota() {
    if (this.nota || this.nota === 0) {
      let validation = NotaValidator.isNotaValid(this.nota)

      if (validation.valid) {
        this.confirmarNota.emit(this.nota)
        this.showSavedFeedback()
        return
      }

      this.unespCoreMessageService.showMessageError(validation.message!)
    }
  }

  private showSavedFeedback(): void {
    this.saved = true
    if (this.savedTimeout) clearTimeout(this.savedTimeout)
    this.savedTimeout = setTimeout(() => this.saved = false, 3000)
  }

  getDescricaoTipoProva(): string {
    if (!this.descricaoProva) return ''
    const prova = TipoProva[this.descricaoProva as keyof typeof TipoProva]
    return prova ? prova.nome : ''
  }
}
